import { Vector2 } from "../Engine";
import { Sizes } from "./";

export class SoccerPlaygroundConfig {
    totalWidth: number = 0;
    conversionFactor: number = 0;
    totalHeight: number = 0;
    height: number = 0;
    bottomLeftCorner: Vector2 = Vector2.zero;
    topRightCorner: Vector2 = Vector2.zero;
    bottomRightCorner: Vector2 = Vector2.zero;
    centerPoint: Vector2 = Vector2.zero;
    footballSpeed: number = 100;

    showAngleOfBisectorLine: boolean = true;
    showLineToPosts: boolean = true;

    constructor(public topLeftCorner: Vector2, public width: number) {
        this.recalculate();
    }

    recalculate(): void {
        this.conversionFactor = this.width / Sizes.PlaygroundWith;

        this.totalWidth = this.width + 2 * this.topLeftCorner.x;
        this.totalHeight = Sizes.PlaygroundHeight * this.conversionFactor + 2 * this.topLeftCorner.y;

        this.height = this.conversionFactor * Sizes.PlaygroundHeight;

        this.bottomLeftCorner = new Vector2(this.topLeftCorner.x, this.topLeftCorner.y + this.height);
        this.topRightCorner = new Vector2(this.topLeftCorner.x + this.width, this.topLeftCorner.y);
        this.bottomRightCorner = new Vector2(this.topLeftCorner.x + this.width, this.topLeftCorner.y + this.height);

        this.centerPoint = new Vector2(
            this.topLeftCorner.x + this.width / 2.0,
            this.topLeftCorner.y + this.height / 2.0
        );
    }

}